import jsPDF from 'jspdf';
import moment from 'moment';
import { Comment, IInspectionReport } from 'redux/conductInspectionSlice';
import { Team } from 'redux/projectSlice';
import Logo from 'assets/images/logo.png';
import starFill from 'assets/images/starFill.png';
import star from 'assets/images/star.png';
import {
  addBorderAndFooter,
  addNewPage,
  addText,
  addTitle,
  addTwoText,
  NEXT_LINE_OFFSET,
  addImageWithUrl,
  addTextAsImage,
} from 'helper/download';

export const downloadInspectionReport = (
  report: IInspectionReport,
  team: Team[],
) => {
  const pdf = new jsPDF({ compress: true });
  const x = 25;

  const { inspectionInfo, projectInfo, tasks } = report;

  addBorderAndFooter(pdf);
  pdf.setFontSize(12);
  pdf.setTextColor('#000');
  pdf
    .setFont(undefined as any, 'bold')
    .text('Project Name -', x, 20)
    .setFont(undefined as any, 'normal')
    .text(`${projectInfo.projectName}`, x + 32, 20)
    .setFont(undefined as any, 'bold')
    .text('Project Id -', x, 28)
    .setFont(undefined as any, 'normal')
    .text(`${projectInfo.projectDisplayId}`, x + 23, 28)
    .setFont(undefined as any, 'bold')
    .text('Inspection Report - ', x, 36)
    .setFont(undefined as any, 'normal')
    .text(`${inspectionInfo.displayId}`, x + 40, 36)
    .setFont(undefined as any, 'bold')
    .text('Report Date - ', x, 44)
    .setFont(undefined as any, 'normal')
    .text(`${moment().format('DD-MM-yyyy')}`, x + 28, 44)
    .addImage(Logo, 130, 20, 55, 20);
  pdf.line(x, 50, 185, 50);

  addTitle(pdf, 'SUMMARY', x, 60);

  let py = 70;

  py = addTwoText(
    pdf,
    x,
    py,
    'Sub Projects -',
    Object.values({
      subProject: inspectionInfo.subProject?.name ?? '',
      subTask: inspectionInfo.subTask?.name ?? '',
      endTask: inspectionInfo.endTask?.name ?? '',
    })
      .filter((value) => value)
      .join(' -> '),
  );

  py = addTwoText(
    pdf,
    x,
    py,
    'Tags -',
    inspectionInfo.locations?.join(', ') ?? '',
  );
  py = addTwoText(
    pdf,
    x,
    py,
    'Checklist -',
    inspectionInfo.checklistInfo.checklistName,
  );
  py = addTwoText(
    pdf,
    x,
    py,
    'Inspection Start Date -',
    moment(inspectionInfo.inspectionDate ?? inspectionInfo.updated_at).format(
      'DD-MM-yyyy',
    ),
  );
  py = addTwoText(pdf, x, py, 'Inspector -', inspectionInfo.inspector ?? '');
  py = addTwoText(pdf, x, py, 'Inspection Status -', inspectionInfo.status);
  py = addTwoText(pdf, x, py, 'Doer -', inspectionInfo.doer);

  py = addTwoText(
    pdf,
    x,
    py,
    'Re-inspection Tasks -',
    tasks?.length > 0 ? '' : 'No Pending Tasks',
  );

  tasks.forEach((task, i) => {
    py = addTwoText(pdf, x + 10, py, `Task -${i + 1} -`, task.name);
    py = addTwoText(pdf, x + 10, py, `Current Action Status -`, task.status);
    py = addTwoText(pdf, x + 10, py, `Last Action By -`, task.updatedBy);
    py += 2;
  });

  pdf.setFont(undefined as any, 'bold');

  py = addText(pdf, x, py, 'Inspection Rating -');

  for (let i = 0; i < 6; i++) {
    pdf.addImage(
      i < (inspectionInfo.satisfactionLevel ?? 0) ? starFill : star,
      x + pdf.getTextWidth('Inspection Rating -') + (i > 0 ? i * 6 : 6),
      py - 14,
      5,
      5,
    );
  }

  pdf.setFont(undefined as any, 'normal');

  py = addTwoText(
    pdf,
    x,
    py,
    'General Feedback -',
    inspectionInfo.generalFeedback ?? 'N/A',
  );

  pdf.setFont(undefined as any, 'bold');

  pdf.setFontSize(9);

  py = addText(pdf, x, py + 5, 'Attachment with this report', true);
  pdf.setFontSize(8);
  py = addText(pdf, x + 10, py - 5, ' \u2022  Filled Checklist', true);
  py = addText(pdf, x + 10, py - 5, ' \u2022  Task History', true);
  py = addText(pdf, x + 10, py - 5, ' \u2022  Document Photo', true);
  py = addText(pdf, x + 10, py - 5, ' \u2022  Drawing Title Photo', true);
  py = addText(pdf, x + 10, py - 5, ' \u2022  Doer Photo', true);

  pdf.setFontSize(12);

  pdf.setDrawColor('#604596');
  pdf.setFillColor('#604596');
  pdf.rect(25, py, 160, 10, 'F');

  pdf.text(inspectionInfo.eSign ?? '', 145, py - 2);
  pdf.setTextColor('#fff');
  pdf.text('Inspector E-Sign', 140, py + 6);
  pdf.setTextColor('#000');

  pdf.setFont(undefined as any, 'normal');

  // ------------------------------ Questions --------------------------------------

  addNewPage(pdf);

  const title = `# ${inspectionInfo.checklistInfo.checklistName} Checklist`;

  addTitle(pdf, title);

  const questions = Object.values(inspectionInfo.response ?? {});

  for (var i = 0, y = 30; i < questions.length; i++) {
    pdf.setFont(undefined as any, 'bold');
    // y = addText(
    //   pdf,
    //   25,
    //   y,
    //   `Question - ${i + 1}: ${questions[i].question ?? ''}`,
    // );
    y = addTextAsImage(
      pdf,
      25,
      y,
      `Question - ${i + 1}: ${questions[i].question ?? ''}`,
    );
    pdf.setFont(undefined as any, 'normal');
    y = addText(pdf, 30, y, `Response: ${questions[i].response ?? ''}`);

    pdf.text(
      `Re-Inspection Required - ${
        questions[i].requireReinspection ? 'YES' : 'NO'
      }`,
      70,
      y - NEXT_LINE_OFFSET,
    );
    pdf.setTextColor('#000');
    y = addTextAsImage(
      pdf,
      25,
      y,
      `Comment: ${
        questions[i].comments?.[0]?.inspectionComment
          ? questions[i].comments?.[0]?.comment
          : '-' ?? '-'
      }`,
    );

    if (questions[i].comments?.[0]?.documents.length > 0) {
      const { documents } = questions[i].comments?.[0];

      for (let im = 0; im < documents.length; im++) {
        y = addImageWithUrl(pdf, x, y, documents[im].url, 'Attachment:');
      }
    }
  }

  pdf.setFont(undefined as any, 'normal');

  addNewPage(pdf);

  y = 20;

  addTitle(pdf, 'Re-Inspection Tags');

  y += 10;

  pdf.setFontSize(12);
  pdf.setTextColor('#000');

  if (tasks?.length > 0) {
    tasks.forEach((task) => {
      const questionInfo = inspectionInfo.response?.[task.questionId];
      y = addTwoText(pdf, x, y, 'Task Name -', task.name);

      pdf.setFont(undefined as any, 'bold');
      y = addTextAsImage(
        pdf,
        25,
        y,
        `Question - ${questionInfo?.question ?? ''}`,
      );
      pdf.setFont(undefined as any, 'normal');

      y = addTwoText(pdf, x, y, 'Current Status -', task.status);

      questionInfo?.comments.forEach((comment, i) => {
        y = addTwoText(pdf, x, y, 'Message: ', comment.comment);
        y = addTextAsImage(
          pdf,
          x,
          y,
          `Action Taken -${
            (comment as Comment).action?.split('_').join(' ') ?? 'N/A'
          }`,
        );
        y = addTwoText(
          pdf,
          x,
          y,
          'Action Taken By -',
          team.find((t) => t.userId === (comment as Comment).senderId)?.name ??
            '',
        );
        y = addTwoText(
          pdf,
          x,
          y,
          'Comment Date -',
          moment(moment((comment as Comment).commentedAt).toISOString()).format(
            'DD-MM-YYYY',
          ),
        );

        if (comment.documents?.length > 0) {
          y = addImageWithUrl(
            pdf,
            x,
            y,
            comment.documents?.[0].url,
            'Attachment:',
          );
        }

        if (i < questionInfo.comments.length - 1) {
          pdf.line(x, y - 5, 180, y - 5);
        }
      });

      y = y + 5;
    });
  } else {
    y = addText(pdf, x, y, 'No Tags were raised!', true);
  }

  if (
    inspectionInfo.doerImages?.length ||
    inspectionInfo.submissionDocuments?.length ||
    inspectionInfo.drawingTitle?.length
  ) {
    addNewPage(pdf);

    if ((inspectionInfo.submissionDocuments?.length ?? 0) > 0) {
      y = addText(pdf, x, y, 'Document Photo:', true);
      for (let im = 0; im < inspectionInfo.submissionDocuments!.length; im++) {
        y = addImageWithUrl(
          pdf,
          x,
          y,
          inspectionInfo.submissionDocuments![im].url,
        );
      }
    }
    if ((inspectionInfo.submissionDocuments?.length ?? 0) > 0) {
      y = addText(pdf, x, y, 'Drawing title Photo:', true);
      for (let im = 0; im < inspectionInfo.drawingTitle!.length; im++) {
        y = addImageWithUrl(pdf, x, y, inspectionInfo.drawingTitle![im].url);
      }
    }
    if ((inspectionInfo.doerImages?.length ?? 0) > 0) {
      y = addText(pdf, x, y, 'Doer Images:', true);
      for (let im = 0; im < inspectionInfo.doerImages!.length; im++) {
        y = addImageWithUrl(pdf, x, y, inspectionInfo.doerImages![im].url);
      }
    }
  }

  pdf.save(
    `Inspection Report - ${inspectionInfo.displayId}-${moment(
      inspectionInfo.updated_at,
    ).format('DD-MM-YYYY')}`,
  );
};
